import { HOUR_IN_MILLISECONDS } from 'config';
import {
  PublicPourApprovalViewDto,
  useGetPublicPour
} from 'providers/api';
import { UseQueryResult } from 'react-query';
import { PourApprovalPageParams } from './constants';

export type PourApprovalPageQueries = [
  UseQueryResult<PublicPourApprovalViewDto>,
];

const usePourApprovalPageQueries = (params: PourApprovalPageParams): PourApprovalPageQueries => {
  const pourQuery = useGetPublicPour(
    {
      mineModelId: params.projectId as string,
      pourId: params.pourId as string,
      token: params.accessToken as string,
    },
    { staleTime: HOUR_IN_MILLISECONDS },
  );

  return [pourQuery];
};

export default usePourApprovalPageQueries;
